import { compose, withState, withHandlers, lifecycle, mapProps } from 'recompose'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import { updateProductQuantity } from './actions'
import { NATURAL_NUMBER_REGEXP } from '../../constants'
import ProductQuantityInput from './ProductQuantityInput'
import { setUpdatingBlock } from 'components/common/UpdatingBlock/actions'
import { SHOPPING_QUOTE_TOTAL_QUANTITY } from 'components/common/UpdatingBlock/constants'

const DEBOUNCE_INTERVAL = 1000


const withQuantityHandlers = withHandlers({
  increaseHandler: ({
    commerceItemId,
    updateProductQuantity,
    quantity,
    setQuantity,
    maxValue = Infinity,
    step = 1,
    setUpdatingBlock
  }) => () => {
    if (quantity < maxValue) {
      const newQuantity = (parseInt(quantity, 10) + step).toString()
      if ((newQuantity.match(NATURAL_NUMBER_REGEXP)) || !newQuantity) {
        setQuantity(newQuantity)
        setUpdatingBlock({ name: SHOPPING_QUOTE_TOTAL_QUANTITY, value: true })
        updateProductQuantity({ commerceItemId, isPromoExist: 'true', quantity: newQuantity })
      }
    }
  },
  decreaseHandler: ({
    commerceItemId,
    updateProductQuantity,
    quantity,
    setQuantity,
    minValue = 0,
    step = 1,
    setUpdatingBlock
  }) => () => {
    if (quantity > minValue) {
      const newQuantity = (parseInt(quantity, 10) - step).toString()
      if ((newQuantity.match(NATURAL_NUMBER_REGEXP)) || !newQuantity) {
        setQuantity(newQuantity)
        setUpdatingBlock({ name: SHOPPING_QUOTE_TOTAL_QUANTITY, value: true })
        updateProductQuantity({ commerceItemId, isPromoExist: 'true', quantity: newQuantity })
      }
    }
  }
})

const withQuantityUpdateFromProps = lifecycle({
  componentDidUpdate({ value }) {
    if (this.props.value !== value) {
      this.props.setQuantity(this.props.value)
    }
  }
})

const withQuantityState = withState('quantity', 'setQuantity', ({ value }) => value)

const withDebouncedQuantity = mapProps(({ updateProductQuantity, ...props }) => ({
  ...props,
  updateProductQuantity: debounce(updateProductQuantity, DEBOUNCE_INTERVAL)
}))

export default compose(
  connect(null, { updateProductQuantity, setUpdatingBlock }),
  withDebouncedQuantity,
  withQuantityState,
  withQuantityHandlers,
  withQuantityUpdateFromProps
)(ProductQuantityInput)
